<template>
    <div>
      <h1>关于我们</h1>
      <p>这是一个关于页面。</p>
    </div>
  </template>
  